module.exports = __webpack_public_path__ + "img/193b03fa39e2db16ba333d43d58bc214.c5a14109.gif";